import { useEffect, useMemo } from 'react'
import Persona from 'persona'

import { logError, logInfo } from '@sputnik/utils/loggerUtils'

type PersonaClientProps = {
  inquiryId: string
  setInquiryId: (inquiryId: string | null) => void
}

const PersonaClient = ({ inquiryId, setInquiryId }: PersonaClientProps) => {
  const client = useMemo(
    () =>
      new Persona.Client({
        inquiryId,
        environmentId: window.__DivvyEnvironment.PERSONA_ENV || 'sandbox',
        onCancel: ({ inquiryId }) => {
          logInfo('personaQueryCancelled', {
            attributes: { inquiryId, result: `${inquiryId} exit` },
            eventName: 'PersonaClientOnCancel',
          })
          setInquiryId(null)
        },
        onComplete: ({ inquiryId, status }) => {
          logInfo('personaQueryComplete', {
            attributes: { inquiryId, result: `${inquiryId} ${status}` },
            eventName: 'PersonaClientOnComplete',
          })
          setInquiryId(null)
        },
        onError: (error) => {
          console.error('Inquiry error:', error)
          logError(error, {
            attributes: {
              action: 'personaQueryError',
              inquiryId,
              result: `${error.status} — ${error.code}`,
            },
            eventName: 'PersonaClientOnError',
          })
          setInquiryId(null)
        },
      }),
    [inquiryId, setInquiryId],
  )

  useEffect(() => {
    if (inquiryId) {
      client.open()
    }

    return () => {
      client.destroy()
    }
  }, [inquiryId, client])

  return null
}

export default PersonaClient
